<template>
  <div class="container">
    <div class="dept-title">{{ selectedDepartmentData.text }}</div>
    <div class="week-box">
      <div
        @click="select(wkItem)"
        class="week-item"
        v-for="(wkItem, index) in reckonDateList"
        :key="index"
      >
        <div class="select-box">
          <div
            :class="
              wkItem.dateStr == selectWk ? 'wk-item-day-active' : 'wk-item-day'
            "
          >
            {{ wkItem.ListDays }}
          </div>
        </div>
        <div class="wk-item-text">{{ wkItem.ListWeeks }}</div>
      </div>
    </div>
    <div class="list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="listIng"
        @click="goSelectDoctor(item)"
      >
        <div class="top">
          <div><img src="../../assets/room.png" /></div>
          <div>出诊医生{{ item.DRNUM }}人</div>
        </div>
        <div class="bottom">{{ item.CLINICROOM_DESC }}</div>
      </div>
    </div>
    <van-empty
      v-if="list == ''"
      class="custom-image"
      image="https://img.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无数据"
    />
  </div>
</template>

<script>
import { getBaseUrl } from '../../utils/request'
import { getRoomList } from '@/api/api'
import { reckonDate, _date_ } from '../../utils/calculationDate'
export default {
  name: 'selectRoom',
  data() {
    return {
      selectedDepartmentData: [],
      selectWk: '',
      reckonDateList: [],
      list: []
    }
  },
  created() {},
  mounted() {
    // 日期列表
    this.reckonDateList = reckonDate()
    //  获取选中的科室数据
    this.selectedDepartmentData = JSON.parse(localStorage.getItem('department'))
    // 默认当天时间
    this.selectWk = this.reckonDateList[0].dateStr
    console.log(this.reckonDateList, this.selectWk)
    this.getData(
      this.selectedDepartmentData.code,
      this.reckonDateList[0].dateStr
    )
  },
  methods: {
    goSelectDoctor(data) {
      let D = {
        ...this.selectedDepartmentData,
        clinicRoomNo: data.CLINICROOM_NO,
        roomText: data.CLINICROOM_DESC,
        dateStr: this.selectWk
      }
      localStorage.setItem('department', JSON.stringify(D))
      this.$router.push({
        name: 'selectDoctor'
      })
    },
    select(item) {
      this.selectWk = item.dateStr
      this.getData(this.selectedDepartmentData.code, item.dateStr)
    },
    getData(id, dateStr) {
      this.$loading.show()
      let data = {
        deptCode: id,
        admDate: dateStr
      }
      getRoomList(data).then(res => {
        try {
          this.list = JSON.parse(res.msg)
          console.log(this.list)
          this.$loading.hide()
        } catch (error) {
          console.error(error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
}
.dept-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  padding: 0 10px;
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.week-box {
  width: 100%;
  overflow-x: auto;
  height: 70px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
}
.week-item {
  width: 14vw;
  min-width: 14vw;
  font-size: 12px;
  text-align: center;
  .select-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .wk-item-day {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      width: 25px;
      border-radius: 12.5px;
      margin-top: 10px;
      &-active {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        width: 25px;
        border-radius: 12.5px;
        margin-top: 10px;
        background-color: #3478f7;
        color: #fff;
      }
    }
  }
  .wk-item-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
}
.listIng {
  width: 50%;
  margin: 20px 0px;
  font-size: 14px;
  .top {
    color: #999999;
    width: 120px;
    height: 90px;
    background-color: rgb(243, 243, 243);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    text-align: center;
    margin: auto;
    div {
      width: 100%;
      img {
        margin-top: 20px;
        margin-bottom: 5px;
      }
    }
  }
  .bottom {
    color: #ffffff;
    width: 120px;
    height: 30px;
    background-color: rgb(233, 122, 32);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
    margin: auto;
    padding-top: 6px;
  }
}
</style>
